export interface StudentTeachingState {
  currentIndependentItemId: null | string;
}

const state: StudentTeachingState = {
  currentIndependentItemId: null,
};

export default state;
